import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const VoucherList = observer(class VoucherList extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSelect = this.handleSelect.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);

    // Set the initial state
    this.state = {
      sortOrder: 'ASC'
    };
  }

  handleEdit(e, voucherSid) {
    e.preventDefault();

    this.props.routing.push(`/vouchers/edit/${voucherSid}`);
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.props.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.props.parent.setState({
      selectedRows
    });
  }

  applyFilters(e) {
    const { VoucherStore } = this.props.store;

    if(e) {
      e.preventDefault();
    }

    const filters = {};

    const status = this.status.value;
    const tag = this.tag.value;
    const memo = this.memo.value;
    const code = this.code.value;
    const sortOrder = this.state.sortOrder;

    if(status) {
      filters.status = status;
    }

    if(tag) {
      filters.tag = `*${tag}*`;
    }

    if(memo) {
      filters.memo = `*${memo}*`;
    }

    if(code) {
      filters.voucherCode = `*${code}*`;
    }

    if(sortOrder) {
      filters.sortOrder = sortOrder;
    }

    VoucherStore.filters = filters;

    if(Object.keys(filters).length > 0) {
      VoucherStore.getVouchers();
    } else {
      this.resetFilters();
    }
  }

  resetFilters() {
    const { VoucherStore } = this.props.store;

    this.status.value = '';
    this.tag.value = '';
    this.memo.value = '';
    this.code.value = '';

    VoucherStore.filters = {};
    VoucherStore.getVouchers();
  }

  renderVouchers() {
    const { translation, vouchers } = this.props;
    const { SessionStore, VoucherStore } = this.props.store;
    const { userTimezone } = SessionStore;

    return (
      <div>
        <form
          className="filter"
          onSubmit={this.applyFilters}
        >
          <div className="wrap">
            <fieldset>
              <ul className="fields fields--inline">
                <li>
                  <legend>{translation.filter}:</legend>
                </li>
                <li>
                  <label className="select">
                    <select
                      defaultValue={VoucherStore.filters.status}
                      ref={(input) => { this.status = input }}
                    >
                      <option value="">{translation.filters.all}</option>
                      <option value="pending-activation">{translation.filters.pending}</option>
                      <option value="activated">{translation.filters.activated}</option>
                      <option value="redeemed">{translation.filters.redeemed}</option>
                    </select>
                  </label>
                </li>

                <li>
                  <label className="meta" htmlFor="filter-code">
                    {translation.code}
                  </label>

                  <input
                    id="filter-code"
                    type="text"
                    placeholder={translation.code}
                    defaultValue={
                      VoucherStore.filters.code ? VoucherStore.filters.code.replace(/^\*/, '') : ''
                    }
                    ref={(input) => this.code = input}
                  />
                </li>

                <li>
                  <label className="meta" htmlFor="filter-tag">
                    {translation.tag}
                  </label>

                  <input
                    id="filter-tag"
                    type="text"
                    placeholder={translation.tag}
                    defaultValue={
                      VoucherStore.filters.tag ? VoucherStore.filters.tag.replace(/^\*/, '') : ''
                    }
                    ref={(input) => this.tag = input}
                  />
                </li>

                <li>
                  <label className="meta" htmlFor="filter-memo">
                    {translation.memo}
                  </label>

                  <input
                    id="filter-memo"
                    type="text"
                    placeholder={translation.memo}
                    defaultValue={
                      VoucherStore.filters.memo ? VoucherStore.filters.memo.replace(/^\*/, '') : ''
                    }
                    ref={(input) => this.memo = input}
                  />
                </li>

              </ul>
            </fieldset>

            <div className="actions">
              <button
                className="btn"
                type="submit"
              >
                {translation.filter}
              </button>

              <button
                className="btn btn--outline"
                type="reset"
                onClick={this.resetFilters}
              >
                {translation.reset}
              </button>
            </div>
          </div>
        </form>

        <div className="wrap">
          {vouchers.length > 0 &&
            <table>
              <thead>
                <tr>
                  <th id="heading-select" scope="col">
                    <span className="meta">Select</span>
                  </th>
                  <th id="heading-code" className="subtitle" scope="col">
                    {translation.code}
                  </th>
                  <th id="heading-amount" className="subtitle" scope="col">
                    {translation.amount}
                  </th>
                  <th id="heading-balance" className="subtitle" scope="col">
                    {translation.balance}
                  </th>
                  <th id="heading-assigned" className="subtitle" scope="col">
                    {translation.assigned}
                  </th>
                  <th id="heading-status" className="subtitle" scope="col">
                    {translation.status}
                  </th>
                  <th
                    id="heading-purchased"
                    className={`subtitle${this.state.sortOrder === 'ASC' ? ' sort--asc' : ' sort--desc'}`}
                    scope="col"
                    onClick={() => {
                      this.setState({ sortOrder: this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC' }, () => {
                        this.applyFilters();
                      });
                    }}
                  >
                    {translation.purchased_date}
                  </th>
                  <th id="heading-details" className="subtitle" scope="col">
                    <span className="meta">{translation.details}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {vouchers.map(
                  (key, i) =>
                    <tr
                      className={
                        this.props.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : ''
                      }
                      key={i}
                    >
                      <td className="check-col" aria-labelledby="heading-select">
                        <input
                          id={`select-${key.sid}`}
                          className="checkbox-input"
                          type="checkbox"
                          onChange={(e) => this.handleSelect(e, key.sid)}
                        />

                        <label
                          className="checkbox-label checkbox-label--solo" htmlFor={`select-${key.sid}`}
                        >
                          <span className="meta">Select {key.title}</span>
                        </label>
                      </td>

                      <td aria-labelledby="heading-code">
                        <Link
                          to={`/vouchers/edit/${key.sid}`}
                          onClick={(e) => { this.handleEdit(e, key.sid) }}
                          title={`Edit ${key.voucherCode}`}
                        >
                          {key.voucherCode}
                        </Link>
                      </td>

                      <td aria-labelledby="heading-amount" className="number">
                        {currencyFormatter.format(key.amount, { code: key.currency })} {key.currency}
                      </td>

                      <td aria-labelledby="heading-balance" className="number">
                        {currencyFormatter.format(key.amountRemaining, { code: key.currency })}
                      </td>

                      {key.assignedToSid &&
                        <td aria-labelledby="heading-assigned" className="checked">
                          <span className="meta">{translation.assigned}</span><icons.iconCheck />
                        </td>
                      }

                      {!key.assignedToSid &&
                        <td aria-labelledby="heading-assigned"></td>
                      }

                      {key.status &&
                        <td aria-labelledby="heading-status" className={key.status}>
                          <span className="capitalize">{key.status.replace('-', ' ')}</span>
                        </td>
                      }

                      <td aria-labelledby="heading-purchased" className="number">
                        {moment(key.datePurchased).tz(userTimezone).format('M/D/YYYY h:mma')}
                      </td>

                      <td aria-labelledby="heading-details" className="number">
                        <Link
                          to={`/vouchers/edit/${key.sid}`}
                          onClick={(e) => { this.handleEdit(e, key.sid) }}
                        >
                          {translation.details}
                        </Link>
                      </td>
                    </tr>
                )}
              </tbody>
            </table>
          }

          {/* No results */}
          {vouchers.length === 0 &&
            <span className="no-results">
              {translation.no_results}
            </span>
          }

          {vouchers.length === 0 &&
            this.status &&
            !this.status.value &&
            !this.tag.value &&
            !this.code.value &&
            !this.memo.value &&
            <div className="cta">
              <strong className="cta__copy">
                {translation.no_vouchers.heading}
              </strong>

              <button
                className="cta__btn btn--icn-right"
                onClick={(e) => { this.props.toggleDrawer(e, this.props.parent, 'AddVoucher') }}
              >
                {translation.no_vouchers.button}
                <icons.iconPlus className="icon" />
              </button>
            </div>
          }
        </div>
      </div>
    )
  }

  render() {
    const { translation } = this.props;

    if(this.props.drawer) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          {this.renderVouchers()}
        </div>
      )
    } else {
      return this.renderVouchers();
    }
  }
})

export default translate('VoucherList')(VoucherList);


// WEBPACK FOOTER //
// ./src/app/components/Vouchers/VoucherList.js